import React from 'react';

import NafExclusion from '../../components/Setup/NafExclusion';

function NafExclusionView() {
  return <NafExclusion />;
}

export default NafExclusionView;
